import { useFetch } from '../../hooks/useFetch';
import {
	EasyStepsData,
	ExpandedEasyStepsBlock,
} from '../../types/optimizely/blocks/easyStepsBlock';

export const useEasyStepsBlockData = (
	blockId: string,
): EasyStepsData | null => {
	const { data } = useFetch<ExpandedEasyStepsBlock>(blockId);
	if (data) {
		return {
			title: data?.title?.value,
			contentLink: data.contentLink,
			backgroundColor: data?.backgroundColor?.value,
			fontColor: data?.fontColor?.value,
			ctaButtonLabel: data.ctaButtonLabel.value ?? '',
			showCTAButton: data.showCtaButton.value ?? false,
			rows:
				data.rows?.expandedValue?.map((row) => ({
					rowTitle: row.rowTitle.value,
					contentLink: row.contentLink,
					steps: row.steps.value?.length,
				})) ?? [],
		};
	}

	return null;
};
